import { useCallback, useEffect, useState } from 'react';
import { Menu, Input } from 'antd';
import './index.scss';
import { t } from 'i18next';
import { SearchOutlined } from '@ant-design/icons';
import { CloseCircleFilledIcon } from 'tdesign-icons-react';

type Props = {
  timbreLanguages: {
    code: string;
    name: string;
    flag?: string;
  }[];
  onClick?: (item: any) => void;
  onLangVisibleChange?: (item: any) => void;
  curLanguage: {
    code: string;
    name: string;
    flag?: string;
  };
};
const LangMenu = (props: Props) => {
  const [isSearch, setIsSearch] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [filteredData, setFilteredData] = useState<
    {
      code: string;
      name: string;
    }[]
  >([]);
  const { timbreLanguages, onClick, onLangVisibleChange, curLanguage } = props;
  useEffect(() => {
    onSearch('');
  }, [timbreLanguages]);
  const onSearch = (value: string) => {
    if (!value) {
      setIsSearch(false);
      setFilteredData(timbreLanguages);
      return;
    }
    const filtered = timbreLanguages?.filter((item) => item.name.toLowerCase().includes(value.toLowerCase()));
    setFilteredData(filtered);
    setIsSearch(true);
  };

  // 语种下拉菜单配置
  const langMenu =
    timbreLanguages?.length > 1 ? (
      <Menu className="menu_lang">
        <div className="search" key={-1}>
          <Input
            suffix={
              <SearchOutlined
                onClick={() => {
                  onSearch(searchValue);
                }}
              />
            }
            allowClear={{
              clearIcon: (
                <CloseCircleFilledIcon
                  onClick={() => {
                    onSearch('');
                  }}
                />
              ),
            }}
            placeholder={t('搜索')}
            onPressEnter={() => {
              onSearch(searchValue);
            }}
            onChange={(e) => {
              setSearchValue(e.target.value);
              if (!e.target.value) {
                onSearch('');
              }
            }}
          />
        </div>
        {filteredData.length > 0 ? (
          filteredData?.map((item, index) => (
            <Menu.Item
              key={index}
              className={`menu_lang_items ${curLanguage.code === item.code ? 'active' : ''}`}
              onClick={() => (onClick ? onClick(item) : onVisibleChange(item))}
            >
              {item.name}
            </Menu.Item>
          ))
        ) : (
          <div style={{ cursor: 'default', textAlign: 'center', padding: '10px', minWidth: '255px' }}>{t('暂无内容')}</div>
        )}
      </Menu>
    ) : (
      <></>
    );
  const onVisibleChange = useCallback(
    (item) => {
      onLangVisibleChange?.(item);
    },
    [onLangVisibleChange],
  );

  return langMenu;
};
export default LangMenu;
